<template>
<d-container fluid class="main-content-container h-100 px-4 container-fluid">
        <div class="row h-100 no-gutters">
            <div class="auth-form mx-auto my-auto col-md-5 col-lg-3">
                <div class="card">
                <div class="card-body">
                    <img src="@/assets/images/shards-dashboards-logo.svg" alt="Shards Dashboards - Change Password Template" class="auth-form__logo d-table mx-auto mb-3">
                    <h5 class="auth-form__title text-center mb-4">Change Password</h5>
                    <form class="">
                        <div class="form-group">
                            <label for="exampleInputPassword1">Current Password</label>
                            <input id="exampleInputPassword1" type="password" v-model="password" placeholder="Password" class="form-control">
                        </div>
                        <div class="form-group">
                            <label for="exampleInputPassword2">New Password</label>
                            <input id="exampleInputPassword2" type="password" v-model="currentPassword" placeholder="Password" class="form-control">
                        </div>
                        <div class="form-group mb-4">
                            <label for="exampleInputPassword3">Repeat Password</label>
                            <input id="exampleInputPassword3" type="password" v-model="repeatPassword" placeholder="Repeat Password" class="form-control">
                        </div>
                        <button type="submit" @click.prevent="changePassword()" class="btn btn-pill btn-accent d-table mx-auto">Change Password</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
  </d-container>
</template>

<script>
import axios from "axios";
import { sha256, sha224 } from 'js-sha256';

export default {
  name: 'change-password',
  data() {
    return {
      password: "",
      currentPassword: "",
      repeatPassword: "",
    };
  },
  methods: {
    changePassword() {
      
      if(this.currentPassword == this.repeatPassword){
        let pwd = sha256(this.password);
        let rpwd = sha256(this.repeatPassword);
      axios
        .put(process.env.VUE_APP_SERVICE_URL+'api/auth/User/update-password', {
          password: pwd,
          newPassword: rpwd,
        })
        .then(response => {
          console.log(response);
        })
        .catch(err => {
          alert('Password does not match')
        });
      } else {
        alert('Password does not match')
      }
    },
  },
};
</script>